const SelectDataframeType = ({ DataframeTypes, selectedDataframeType, setSelectedDataframeType }) => {
    return (
        <select
        id='dataframe-type-select'
        className='choice-select'
        value={selectedDataframeType}
        onChange={(e) => setSelectedDataframeType(e.target.value)}
        >
            {selectedDataframeType === '' ? <option value="">
                ------
            </option> : null}
            {DataframeTypes.map((dataframe_type) => (
                <option
                    key={dataframe_type}
                    value={dataframe_type}
                >
                    {dataframe_type}
                </option>
            ))}
        </select>
    );
};

export default SelectDataframeType;